import React, {useContext, useEffect, useRef, useState} from 'react';
import { findCurrentLang, readCookie } from './Utils';
import ApplicationContext from './ApplicationContext';
import { getDataWithFetch } from './Utils';

const resetTime = (timeZoneList) => {
    const getTimeByZone = (timeZone) => {
        let now = new Date(Date.now());
        let time = now.toLocaleTimeString(undefined,{timeZone, hour: '2-digit', minute:'2-digit', hour12:true});
        return {name:timeZone?timeZone:"Local Time", time};
    };
    let timeZoneListResult = [];
    timeZoneList?.forEach(entry => {
        let localTime;
    
        if (entry.label === "Local Time") {
            localTime = getTimeByZone()
        }
        else {
            localTime = getTimeByZone(entry.timeZone)
        }
    
        timeZoneListResult.push({name:entry.label, time:localTime.time});
    });
    return timeZoneListResult;
};

const TimeZones = () => {
	const [timeZones, setTimeZones] = useState([]);
	const loaded = useRef(false);
	const data = useContext(ApplicationContext);

    const [timeZoneList, setTimeZoneList] = useState();

	const [currentLangSelection, setCurrentLangSelection] = useState();
	useEffect(() => {
        if (data.BASE_URL) {
            let url, res;
    
            (async() => {
                url = data.BASE_URL + 'index.php/misc/get_time_zones';
                // console.log('DEBUG:', url);
                res = await getDataWithFetch(url);
                setTimeZoneList(res);
            })();
        }
	}, [data.BASE_URL]);

    useEffect(() => {
        if (timeZoneList) {
            // console.log(`DEBUG:  Quote - readCookie("googtrans") = ${readCookie("googtrans")}`);
            // console.log(`DEBUG:  Quote - findCurrentLang(readCookie("googtrans")) = ${findCurrentLang(readCookie("googtrans"))}`);
            setCurrentLangSelection(findCurrentLang(readCookie("googtrans")));
    
            let loop = null;
    
            if (loaded.current === false) {
                loaded.current = true;
    
                // const elem = document.getElementsByClassName(".goog-te-menu-value span:first")[0];
                // console.log(`DEBUG:  Quote - elem - ${JSON.stringify(elem)}`);
    
                document.getElementById("google_translate_element").addEventListener('change', (e) => {
                    // console.log(`DEBUG:  Quote - new value = ${JSON.stringify(e.target.value)}`);
                    setCurrentLangSelection(e.target.value);
                });
    
                setTimeZones(resetTime(timeZoneList));
            }
    
            loop = setInterval(() => {
                setTimeZones(resetTime(timeZoneList));
            }, 60000);
    
            return () => {
                clearInterval(loop);
            }
        }
	}, [timeZoneList]);

	const needTallerTzCells = (lang) => {
        if (!lang) {
            return false;
        }
    
		const foundLang = data?.intl?.find(e => e.lang === lang);
		// console.log(`DEBUG:  foundLang:  ${JSON.stringify(foundLang)}`);

        const res = foundLang?.timeTaller ? true : false;
    
        // console.log(`DEBUG:  res - ${JSON.stringify(res)}`);
        return res;
    };

	return (
		<>
		    {/* {(() => {
                console.log(`DEBUG:  Quote - currentLangSelection:  ${currentLangSelection}`);
            })()} */}
			<h3>World Times</h3>
			<div className="tz-container">
				{timeZones && timeZoneList && timeZones.length === timeZoneList.length && timeZones.map((entry, index, arr) => (
					<div key={index}>
						<div className="tz-item">
							{/* needTallerTzCells(currentLangSelection) */}
							<div className="tz-rows" style={needTallerTzCells(currentLangSelection) ? {height:50} : {}}>
								<div className="time">{entry.time}</div>
								<div className="name">{entry.name}</div>
							</div>
						</div>
					</div>				
				))}
			</div>
		</>
	);
}

export default TimeZones;
